<template>
  <t-dialog
    header="选择事件"
    :visible="visible"
    :footer="false"
    :destroyOnClose="true"
    width="684px"
    :onClose="handleClose"
    class="transfer-dialog"
  >
    <div slot="body" class="body">
      <t-transfer
        theme="primary"
        :data="options"
        v-model="targetValue"
        :search="true"
        :showCheckAll="false"
        targetSort="push"
        class="event-transfer"
      />
      <div class="btn-cont">
        <t-button variant="outline" @click="handleCancel" class="btn">取消</t-button>
        <t-button @click="handleSure" class="btn">确认</t-button>
      </div>
    </div>
  </t-dialog>
</template>

<script>
import lodash from 'lodash';

export default {
  name: 'select-interest-event-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    interestEvents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      targetValue: [],
    };
  },
  watch: {
    interestEvents: {
      handler() {
        this.initTargetValue();
      },
      deep: true,
    },
  },
  mounted() {
    this.initTargetValue();
  },
  computed: {
    localInterestEvents() {
      return lodash.cloneDeep(this.interestEvents).slice(1, this.interestEvents.length);
    },
    options() {
      const options = this.eventList.map(item => ({ label: item.eventShowName, value: item.eventName }));
      this.localInterestEvents.forEach(item => {
        const temp = this.localInterestEvents.filter(i => i.eventName === item.eventName);
        if (temp.length > 1) {
          options.push({
            label: `${item.name || '未选择'}(${item.showLabel})`,
            value: `${item.showLabel}###${item.eventName}`,
          });
        }
        if (temp.length === 1 && !item.eventName) {
          options.push({
            label: `未选择(${item.showLabel})`,
            value: `${item.showLabel}###${item.eventName}`,
          });
        }
      });
      return options;
    },
  },
  methods: {
    initTargetValue() {
      const targetValue = [];
      this.localInterestEvents.forEach(item => {
        const temp = this.localInterestEvents.filter(i => i.eventName === item.eventName);
        if (temp.length > 1) {
          targetValue.push(`${item.showLabel}###${item.eventName}`);
        } else if (temp.length === 1 && !item.eventName) {
          targetValue.push(`${item.showLabel}###${item.eventName}`);
        } else {
          targetValue.push(item.eventName);
        }
      });
      this.targetValue = targetValue;
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleCancel() {
      this.$emit('update:visible', false);
    },
    handleSure() {
      if (this.targetValue.length > 9) {
        this.$message.warning('最多选择9个事件');
        return;
      }
      this.$emit('update:visible', false);
      this.$emit('sure', lodash.cloneDeep(this.targetValue));
      this.targetValue = [];
    },
  },
};
</script>

<style scoped lang="less">
.transfer-dialog {
  ::v-deep .t-dialog {
    padding: 20px;

    .t-dialog__header {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.event-transfer {
  ::v-deep .t-transfer__list {
    width: 305px;
    height: 412px;
  }

  ::v-deep .t-transfer__operations {
    button {
      margin-left: 0;
    }
  }
}

.btn-cont {
  text-align: center;
  margin-top: 24px;

  .btn {
    font-size: 12px;
    width: 80px;
  }
}
</style>
